import { Collapse, DialogContent, IconButton, Modal, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import axios from '../../util/Axios';
import { useEffect, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import { Box } from '@mui/system';
import TestDetails from '../../components/TestDetails/TestDetails';
import InfoIcon from '@mui/icons-material/Info';
import PatientInfo from './PatientInfo';

export default function PatientRow(props) {
  const [open, setOpen] = useState(false);
  const [tests, setTests] = useState([]);

  const [openVideo, setOpenVideo] = useState(false);
  const [openedTestId, setOpenedTestId] = useState(null);

  const [viewPatientOpen, setViewPatientOpen] = useState(false);
  const [viewedPatient, setViewedPatient] = useState(null);

  const handleOpenVideo = (testId) => {
    setOpenedTestId(testId);
    setOpenVideo(true);
  };

  const handleCloseVideo = () => {
    setOpenVideo(false);
    setOpenedTestId(null);
  };

  const handleOpenPatient = (patient) => {
    setViewPatientOpen(true);
    setViewedPatient(patient);
  };

  const handleClosePatient = () => {
    setViewPatientOpen(false);
    setViewedPatient(null);
  };

  useEffect(() => {
    axios('/strokeTests/details?userId=' + props.patient.uuid).then((data) => {
      const arr = data.data;
      arr.sort((t1, t2) => new Date(t2.createdAt) - new Date(t1.createdAt)); //sort by date desc
      setTests(arr);
    });
  }, [props.patient.uuid]);

  return (
    <>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" disabled={tests.length === 0} onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{props.patient.name}</TableCell>
        <TableCell>{props.patient.age}</TableCell>
        <TableCell>{props.patient.sex}</TableCell>
        <TableCell>{tests.length}</TableCell>
        <TableCell>
          <IconButton onClick={() => handleOpenPatient(props.patient)}>
            <MedicalInformationIcon />
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Tests Done
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Details</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tests.map((test) => (
                    <TableRow key={test.uuid}>
                      <TableCell component="th" scope="row">
                        {test.uuid}
                      </TableCell>
                      <TableCell>{test.createdAt.split('.')[0].replace('T', ' ')}</TableCell>
                      <TableCell>
                        <IconButton onClick={() => handleOpenVideo(test.uuid)}>
                          <InfoIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>

      <Modal open={openVideo} onClose={handleCloseVideo}>
        <DialogContent>
          <TestDetails id={openedTestId} onClose={handleCloseVideo}></TestDetails>
        </DialogContent>
      </Modal>

      <PatientInfo open={viewPatientOpen} patient={viewedPatient} handleClosePatient={handleClosePatient}></PatientInfo>
    </>
  );
}
